import { render, staticRenderFns } from "./AttendanceModules.vue?vue&type=template&id=3b7562d2"
import script from "./AttendanceModules.vue?vue&type=script&lang=js"
export * from "./AttendanceModules.vue?vue&type=script&lang=js"
import style0 from "./AttendanceModules.vue?vue&type=style&index=0&id=3b7562d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports